import { useEffect, useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useMutation } from "@tanstack/react-query";

import { SubmitButton } from "ui-components/Form";
import { Layout } from "ui-components/Layout";
import { Success, Error_ } from "ui-components/Alert";
import { formRender, initialValues, zoneValidations } from "./zone-schema";
import { useWhOptionsQuery } from "hooks/useWhQuery";
import { createZone } from "services/data.internal.service";
import ZoneInfo from "./components/ZoneInfo";
import { useLocation, useNavigate } from "react-router-dom";
import { useCustWhOptionsQuery } from "hooks/useQueryHook";
import { useCustomerValue } from "providers/CustomerContext";

function AddZone() {
  const location = useLocation();
  const navigate = useNavigate();
  const {customerCode} = useCustomerValue()
  let { warehouseCode } = location?.state ?? {};
  warehouseCode = warehouseCode === undefined ? null : warehouseCode;
  const [alert, setAlert] = useState(null);
  const [whOptions, setWhOptions] = useState([]);
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  const createZoneMutation = useMutation(createZone, {
    onSuccess: (data) => setAlert(<Success data={data} onChange={setAlert} />),
    onError,
  });
  const form = useForm({
    defaultValues: initialValues,
    values: { ...initialValues, warehouseCode },
    resolver: yupResolver(zoneValidations),
  });

  const {
    getValues,
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
    setValue,
  } = form;

  useCustWhOptionsQuery({customerCode, onSuccess: (data) => setWhOptions(data.data.data) });

  const infoProps = {
    whOptions,
    getValues,
    control,
    errors,
    setValue,
    formRender,
  };
  const onSubmit = (data) => {
    createZoneMutation.mutate(data, {
      onSuccess: () =>
        navigate("/setup/location/add", {
          state: { warehouseCode: data.warehouseCode, zoneID: data.zoneID },
        }),
    });
  };
  const createStatus = createZoneMutation.status === "loading"
  return (
    <Layout>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <ZoneInfo {...infoProps} />
        <SubmitButton label="submit" disabled={createStatus} url="/setup/zone" />
      </form>
    </Layout>
  );
}

export default AddZone;
